import { type CreditCardRepository } from '@webapp/modules/expense/data-access/repositories/CreditCardRepository'
import { type ReimbursementSettingsRepository } from '@webapp/modules/expense/data-access/repositories/ReimbursementSettingsRepository'
import { AssignedCreditCard } from '@webapp/modules/expense/entities/AssignedCreditCard'
import { type ExpenseFormReimbursementCustomization } from '@webapp/modules/expense/entities/enums'

interface GetExpenseLineItemFormDataParams {
  userId: number
}

interface GetExpenseLineItemFormDataResult {
  reimbursementSetting: ExpenseFormReimbursementCustomization
  creditCards: AssignedCreditCard[]
}

interface Dependency {
  reimbursementSettingsRepository: ReimbursementSettingsRepository
  creditCardRepository: CreditCardRepository
}

export class GetExpenseLineItemFormDataUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = async ({
    userId,
  }: GetExpenseLineItemFormDataParams): Promise<GetExpenseLineItemFormDataResult> => {
    const [reimbursementSetting, creditCardConstructors] = await Promise.all([
      this.deps.reimbursementSettingsRepository.get(),
      this.deps.creditCardRepository.listAssigned(userId),
    ])

    const creditCards = creditCardConstructors.map(
      (constructor) => new AssignedCreditCard(constructor)
    )

    return {
      reimbursementSetting,
      creditCards,
    }
  }
}
